import { render, staticRenderFns } from "./GDropdownOld.vue?vue&type=template&id=7635298c&"
import script from "./GDropdownOld.vue?vue&type=script&lang=js&"
export * from "./GDropdownOld.vue?vue&type=script&lang=js&"
import style0 from "./GDropdownOld.vue?vue&type=style&index=0&id=7635298c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports